/** translate--de */

import * as config from '../config.js';

const de = {
	key: 'de',
	MATH: {
		FRACTION: ','
	},
	APPLY: 'übernehmen',
	HTML: {
		title: 'Lif Konfigurator',
		dsTitle: 'Lif Datenblatt'
	},
	FINISH: {
		INFO: 'Bitte wählen Sie Ihre gewünschte Farbe und klicken Sie übernehmen.',
		HEADER: 'Farbe',
		seluxGraphite: 'Selux Graphit',
		ral9005: 'Tiefschwarz',
		ral7016: 'Anthrazitgrau',
		ral7024: 'Graphitgrau',
		ral7011: 'Eisengrau',
		ral9007: 'Graualuminium',
		ral9006: 'Weißaluminium',
		ral9010: 'Reinweiß',
		ral9016: 'Verkehrsweiß',
		ral6009: 'Tannengrün',
		ral6005: 'Moosgrün',
		ral5003: 'Saphirblau',
		ral3005: 'Weinrot',
		ral3003: 'Rubinrot',
		db703: 'Dunkelgrau Perl',
		db702: 'Silbergrau Perl',
		db701: 'Weißaluminium Perl'
	},
	STEPS: {
		FINISHED: 'fertig',
		NEXT: 'weiter',
		scope: 'Wählen Sie einen oder mehrere Anwendungsbereiche',
		config: 'Konfiguration',
		zoom: 'Konfiguration', // the same as config:
		parameters: 'Lichtverteilung',
		height: 'Konfiguration Höhe',
		upload: 'Konfiguration', // the same as config:
		foto: 'Foto Upload',
		summary: 'Übersicht',
		datasheet: 'Datenblatt'
	},
	// INFO: see translate-info*.js
	INFOBOX: {
		parameters: 'Lichtverteilung',
		height: 'Höhe',
		element: 'Element',
		inset: 'Einsatz',
		elements: 'Elemente',
		insets: 'Einsätze',
		charging: 'Ladestation',
		chargings: 'Ladestationen'
	},
	SCOPE: {
		HEADING: 'Wählen Sie einen oder mehrere Anwendungsbereiche.',
		0: 'Fassade',
		1: 'Platz',
		2: 'Akzentuierung',
		3: 'Weg',
		length: 4
	},
	PRODUCTS: {
		baseDescription: {
			// see below
		},
		description: {
			// see below
		},
		datasheet: {
			// see below
		}
	},
	DATASHEET: {
		LINKTEXT: 'Konfiguration abschließen\nund Datenblatt erzeugen',
		SHORTDESC: 'Lif Systemstele',
		OPENING: 'Aluminium-Strangpressprofil, Aluminium-Druckgussabschlüsse, ',
		FACADE: 'Fassaden-Einsatz: Sicherheitsglas mit polierten Kanten, ',
		TOP: 'Top-Element aus PMMA, ',
		MOUNTING: 'Aufnahme-Element: additiv übereinander stapelbar und frei zwischen 0–360° drehbar, um Beleuchtungen in unterschiedliche Richtungen zu realisieren, optional mit rückseitiger Abdeckung, ',
		TWINSPOT: 'Twinspot-Modul: über ± 45° schwenkbar, Sicherheitsglas mit polierten Kanten, ',
		RGBW: 'Akzent-Element: aus PMMA, ',
		CLOSING: 'Basis-Element aus verzinktem Stahl, mit Fußplatte, LED 3.000/4.000K.',
		FABRICATE: 'Fabrikat: Selux Typ SX 2006',
		COLOUR: 'Farbe:',
		COLORING: 'Selux Graphit oder Farbe nach Wahl',
		DIAMETER: 'Durchmesser  Ø: ',
		HEIGHT: 'Höhe H: ',
		WEIGHT: 'Gewicht: ',
		WINDAGE: 'Windangriffsfläche A: ',
		CONTACTINTRO: 'Für weitere Details oder individuelle Konfigurationen können Sie gerne Kontakt mit uns aufnehmen.',
		CHANGING: 'Aufgrund der stetigen Weiterentwicklung und Verbesserung der LED-Technologie sind Änderungen möglich.',
		CHANGES: ' Technische Änderungen vorbehalten ',
		REQUESTPRICE: 'auf Anfrage',
		HEADING_MOUNTED: 'Elemente',
		HEADING_MODULES: 'Module',
		HEADING_POLE: 'Mast',
		HEADING_ACCESSORIES: 'Zubehör',
		HEADING_HEIGHT: 'Höhe ',
		COL_COUNT: 'Anzahl',
		COL_SX: 'Artikelnr.',
		COL_DESCRIPTION: 'Beschreibung',
		COL_SINGLE_PRICE: 'Stück*',
		COL_TOTAL_PRICE: 'Gesamt*',
		TOTAL: 'Brutto-Listenpreis exkl. MWSt. je konfigurierter Leuchte*',
		TOTAL_HEIGHT: 'Gesamthöhe',
		PRICEINFO: '*Die vorgenannten Preise verstehen sich ohne Montage zzgl. gesetzlicher Mehrwertsteuer.',
		LISTCAPTION: 'Leuchtenkonfiguration',
		CONF_ID: 'Leuchtenkonfiguration'
	},
	STELE: {
		DISTRIBUTION: 'Lichtverteilung',
		BACKCOVER: 'Optionale Abdeckung für Rückseite',
		F_WIDE: 'Breit',
		F_NARROW: 'Eng',
		W_SYM: 'Symmetrisch', // Wege Lichtverteilung
		W_ASYM: 'Asymmetrisch', // Wege Lichtverteilung
		W_SILVER: 'silber',
		W_GOLD: 'gold',
		C_BOSCH: 'Adapterblech für\nBosch FLEXIDOME IP outdoor 5000er',
		C_AXIS: 'Adapterblech für\nAxis Dome P322X',
		C_ENEO: 'Adapterblech für\neneo dome IPD-73M2812M0A',
		RENDERING_DOWNLAOD: 'Download', // Tooltip per CSS bekommt anderen Text, wenn es dann kommt
		SHOW_HEAD: 'Elemente und Module',
		SHOW_BOTTOM: 'Ladestation',
		CHARGING_BASIC: 'Basic',
		CHARGING_ADV: 'Professional',
		CHARGING_PROF: 'Advanced',
		CHARGING_DOOR: 'Tür'
	},
	FOTO: { // from Astro
		CHANGE: 'Hintergrund wechseln',
		RESET: 'Hintergrund zurücksetzen',
		UPLOAD: 'Foto hochladen',
		EDIT: 'Foto bearbeiten',
		ADD: 'Leuchte hinzufügen',
		ACCEPT: 'Leuchtendesign ändern',
		DOWNLOAD: 'Simulation herunterladen'
	},
	UPLOAD: { // from Astro
		UPLOAD: 'Bitte laden Sie Ihre gewünschte Leuchtenumgebung zur Fotosimulation hoch',
		ACCEPT: 'übernehmen',
		CANCEL: 'abbrechen',
		UPLOADBUTTON: 'Datei auswählen',
		ERROR: 'Fehler beim Upload des Fotos',
		WORKING: 'Uploading'
	},
	SUMMARY: {
		TITEL: 'Übersicht der Module und Ihrer Konfiguration im Detail',
		BASE_CONFIGURATION: 'Grundkonfiguration',
		HEIGHT: 'Höhe:',
		CABLEBOX: 'Kabelsicherungskasten',
		EXTRADOORS: 'Zweite Masttür',
		EXTRADOORS2: 'Dritte Masttür',
		CHARGING_BASIC: 'Basic',
		CHARGING_ADV: 'Advanced',
		CHARGING_PROF: 'Professional',
		CAM: 'mit Adapterblech für',
		C_BOSCH: '\nBosch FLEXIDOME IP\noutdoor 5000er Serie',
		C_AXIS: '\nAxis Domekamera P322X Serie',
		C_ENEO: '\neneo network dome IPD-73M2812M0A',
	},
	USER: { //TODO USER translations
		LOGIN_TEXT: 'Login',
		LOGIN_BUTTON: 'Login',
		LOGOUT_BUTTON: 'Logout',
		USERNAME: 'Benutzer/E-Mail',
		PASSWORD: 'Passwort',
		LOAD_TEXT: 'Konfiguration',
		LOAD_BUTTON: 'Laden',
		PRICES_TEXT: 'Preise anzeigen'
	}
};

// de with calculated key

de.PRODUCTS.baseDescription[config.PART_BASIS_NAME] = 'Mast-Basis-Element';
de.PRODUCTS.baseDescription[config.PART_DECKEL_NAME] = 'Stelen-Deckel';
de.PRODUCTS.baseDescription[config.PART_MODUL_RGBW_NAME] = 'Akzent-Element';
de.PRODUCTS.baseDescription[config.PART_MODUL_WEGE_NAME] = 'Top-Element 4-fach';
de.PRODUCTS.baseDescription[config.PART_MODUL_WEGE2_NAME] = 'Top-Element 2-fach';
de.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_500_NAME] = 'Aufnahme-Element 500';
de.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_250_NAME] = 'Aufnahme-Element 250';
de.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1000_NAME] = 'Aufnahme-Element 1000';
de.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1500_NAME] = 'Aufnahme-Element 1500';
de.PRODUCTS.baseDescription[config.PART_MODUL_KAMERA_NAME] = 'Kamera-Element';
de.PRODUCTS.baseDescription[config.PART_MODUL_WLAN_NAME] = 'WiFi-Element';
de.PRODUCTS.baseDescription[config.PART_ELEMENT_SPEAKER_NAME] = 'Lautsprecher-Einsatz';
de.PRODUCTS.baseDescription[config.PART_ELEMENT_VERT_NAME] = 'Wege-Einsatz';
de.PRODUCTS.baseDescription[config.PART_ELEMENT_TWINSPOT_NAME] = 'Twinspot-Einsatz';
de.PRODUCTS.baseDescription[config.PART_ELEMENT_FASSADE_500_NAME] = 'Fassaden-Einsatz';
de.PRODUCTS.baseDescription[config.PART_ELEMENT_GOBO_NAME] = 'Gobo-Einsatz';
de.PRODUCTS.baseDescription[config.PART_MODUL_CHARGING_NAME] = 'Ladestation';

de.PRODUCTS.description[config.PART_BASIS_NAME] = 'Mast-Basis-Element';
de.PRODUCTS.description[config.PART_DECKEL_NAME] = 'Stelen-Deckel';
de.PRODUCTS.description[config.PART_MODUL_RGBW_NAME] = 'Akzent-Element';
de.PRODUCTS.description[config.PART_MODUL_WEGE_NAME] = 'Top-Element\n4-fach';
de.PRODUCTS.description[config.PART_MODUL_WEGE2_NAME] = 'Top-Element\n2-fach';
de.PRODUCTS.description[config.PART_MODUL_AUFNAHME_500_NAME] = 'Aufnahme-Element 500 für\nTwinspot- oder Fassaden-Einsätze';
de.PRODUCTS.description[config.PART_MODUL_AUFNAHME_250_NAME] = 'Aufnahme-Element 250 für\nTwinspot-Einsatz';
de.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1000_NAME] = 'Aufnahme-Element 1000 für\nTwinspot- oder Fassaden-Einsätze';
de.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1500_NAME] = 'Aufnahme-Element 1500 für\nTwinspot- oder Fassaden-Einsätze';
de.PRODUCTS.description[config.PART_MODUL_KAMERA_NAME] = 'Kamera-Element';
de.PRODUCTS.description[config.PART_MODUL_WLAN_NAME] = 'WiFi-Element';
de.PRODUCTS.description[config.PART_ELEMENT_SPEAKER_NAME] = 'Lautsprecher-Einsatz';
de.PRODUCTS.description[config.PART_ELEMENT_VERT_NAME] = 'Wege-Einsatz';
de.PRODUCTS.description[config.PART_ELEMENT_TWINSPOT_NAME] = 'Twinspot-Einsatz';
de.PRODUCTS.description[config.PART_ELEMENT_FASSADE_500_NAME] = 'Fassaden-Einsatz';
de.PRODUCTS.description[config.PART_ELEMENT_GOBO_NAME] = 'Gobo-Einsatz';
de.PRODUCTS.description[config.PART_MODUL_CHARGING_NAME] = 'Ladestation';


export default de;
